/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import { createLoadingSelector, createErrorSelector } from '@a1/core';
import { processActions } from '../../reducer/processReducer';

import logoSplash from '../../images/logo_splash.png';

class AccountSuccess extends Component {
  componentDidMount() {
    const { history, process, resetEmail } = this.props;

    if (!(process.processUserResult && process.processUserResult.isOk === true)) {
      history.push('/confirm');
      return false;
    }

    document.title = 'Страхотно - A1 Xplore TV GO';

    resetEmail();

    try {
      sessionStorage.clear();
    } catch (err) {
      /* */
    }

    return false;
  }

  render() {
    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>
          <div className="container-body">
            <h1 className="tag-title">Страхотно!</h1>

            <div className="tag-content">
              <p>
                Всичко е готово.
                <br />
                Благодарим ти, че избра A1 Xplore TV GO!
              </p>
            </div>

            <div className="tag-content" style={{ marginTop: '40px' }}>
              <a
                href="https://play.google.com/store/apps/details?id=bg.a1.android.xploretv"
                rel="noopener noreferrer"
              >
                <img
                  src="//media.a1.bg/newsite2015/my-mtel/app-popup/my-mtel-app-android.png"
                  alt=""
                  style={{ maxWidth: '160px' }}
                />
              </a>
              <a
                href="https://apps.apple.com/bg/app/a1-xplore-tv-go/id1460357508"
                rel="noopener noreferrer"
              >
                <img
                  src="//media.a1.bg/newsite2015/my-mtel/app-popup/my-mtel-app-ios.png"
                  alt=""
                  style={{ maxWidth: '160px' }}
                />
              </a>
              <a
                href="https://appgallery.cloud.huawei.com/ag/n/app/C101379737"
                rel="noopener noreferrer"
              >
                <img
                  src="//media.a1.bg/newsite2015/my-mtel/app-popup/mya1-huawei-app-gallery.png"
                  alt=""
                  style={{ maxWidth: '160px' }}
                />
              </a>
            </div>

            <div className="tag-content" style={{ marginTop: '40px' }}>
              Можеш да гледаш A1 Xplore TV GO на Android или iOS устройство, както и през{' '}
              <a href="https://new.a1xploretv.bg">браузър</a>.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetEmail: () => dispatch(processActions.resetEmail()),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AccountSuccess);
